import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import AboutSection from "../components/AboutSection";
import TestimonialSection from "../components/TestimonialSection";
import FooterSection from "../components/FooterSection";
import Note from "../components/Note";

export default function About() {
  return (
    <div>
      <Header />
      <PagesHero page={"about"}/>
      <AboutSection />
      <div style={{
        maxWidth: 1125,
        margin: "5rem auto"
      }}>

      <Note />
      </div>
      <TestimonialSection />
      <FooterSection /> 
    </div>
  );
}
